import type {
  ApiNavCatalogDraftResponse,
  ApiNavPublishResult,
  ApiNavReorderRequest,
  ApiNavShell,
  ApiNavTreeResponse,
  ApiPatchNavGroupRequest,
  ApiPatchNavItemRequest,
} from "@tm-food/api-contract";
import type { HttpClient } from "@/shared/api/http";

export async function fetchRuntimeNav(
  http: HttpClient,
  shell: ApiNavShell,
): Promise<ApiNavTreeResponse> {
  const qs = new URLSearchParams({ shell });
  return http.request<ApiNavTreeResponse>(`/api/v1/sys/nav?${qs.toString()}`);
}

export async function fetchNavCatalogDraft(
  http: HttpClient,
  shell: ApiNavShell,
): Promise<ApiNavCatalogDraftResponse> {
  const qs = new URLSearchParams({ shell });
  return http.request<ApiNavCatalogDraftResponse>(
    `/api/v1/sys/nav/catalog?${qs.toString()}`,
  );
}

export async function patchNavDraftGroup(
  http: HttpClient,
  id: string,
  body: ApiPatchNavGroupRequest,
  rowVersion: string,
): Promise<ApiNavCatalogDraftResponse["groups"][number]> {
  return http.request(`/api/v1/sys/nav/draft/groups/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body,
    headers: { "If-Match": rowVersion },
  });
}

export async function patchNavDraftItem(
  http: HttpClient,
  id: string,
  body: ApiPatchNavItemRequest,
  rowVersion: string,
): Promise<ApiNavCatalogDraftResponse["groups"][number]["items"][number]> {
  return http.request(`/api/v1/sys/nav/draft/items/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body,
    headers: { "If-Match": rowVersion },
  });
}

export async function deleteNavDraftItem(
  http: HttpClient,
  id: string,
): Promise<void> {
  await http.request(`/api/v1/sys/nav/draft/items/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}

export async function reorderNavDraft(
  http: HttpClient,
  body: ApiNavReorderRequest,
): Promise<void> {
  await http.request(`/api/v1/sys/nav/draft/reorder`, {
    method: "POST",
    body,
  });
}

export async function publishNav(
  http: HttpClient,
  shell: ApiNavShell,
  comment?: string,
): Promise<ApiNavPublishResult> {
  const qs = new URLSearchParams({ shell });
  return http.request<ApiNavPublishResult>(
    `/api/v1/sys/nav/publish?${qs.toString()}`,
    { method: "POST", body: { comment: comment ?? null } },
  );
}

export async function rollbackNav(
  http: HttpClient,
  shell: ApiNavShell,
  targetVersion: number,
  comment?: string,
): Promise<ApiNavPublishResult> {
  const qs = new URLSearchParams({ shell });
  return http.request<ApiNavPublishResult>(
    `/api/v1/sys/nav/publish/rollback?${qs.toString()}`,
    {
      method: "POST",
      body: { targetVersion, comment: comment ?? null },
    },
  );
}
